export default __webpack_public_path__ + "static/media/close-icon.a18b53e6.svg";